// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"Pagination_paginationWrapper__4o_0i","infoText":"Pagination_infoText__0Ad4A"};